<template>
  <v-app id="backGND">
    <navBar />
    <v-card
      id="card_login"
      style="
        border-radius: 2em;
        margin-top: 7%;
        margin-left: 15%;
        width: 30%;
        background-color: rgba(19, 18, 17, 1);
      "
    >
      <br />
      <h2 style="color: rgba(253, 246, 254, 0.96)">Iniciar sesión</h2>

      <v-container>
        <!-- Email -->
        <p style="margin-top: 1em" class="register-p">Correo Electrónico</p>
        <input class="register-input" type="email" v-model="email" />
        <span class="error_message"
          ><p>{{ error_email }}</p></span
        >

        <!-- Contraseña -->
        <p style="margin-top: 1em" class="register-p">Contraseña</p>
        <div style="width: 100%; display: inline-block">
          <input
            style="width: 88%; display: inline-block"
            class="register-input"
            :type="showPass ? 'text' : 'password'"
            v-model="password"
          />
          <img
            v-if="showPass"
            style="
              cursos: pointer;
              position: relative;
              top: 0.5em;
              color: white;
              width: 6.8%;
              display: inline-block;
            "
            src="../assets/visibility_off.png"
            @click="showPass = !showPass"
          />
          <img
            v-else
            style="
              cursos: pointer;
              position: relative;
              top: 0.5em;
              color: white;
              width: 6.8%;
              display: inline-block;
            "
            src="../assets/visibility.png"
            @click="showPass = !showPass"
          />
        </div>
        <span class="error_message"
          ><p>{{ error_password }}</p></span
        >

        <span style="color: white"
          >¿Olvidaste tu contraseña?
          <router-link to="/recuperar_contrasena">
            <a style="font-weight: 900; color: blue !important">da click aquí</a>
          </router-link>
        </span>
        <br />

        <!-- btn login -->
        <v-btn
          style="
            margin-bottom: 1em;
            margin-top: 2em;
            background-color: rgba(253, 246, 254, 0.96);
          "
          @click="login()"
          >Iniciar sesión</v-btn
        >

        <span class="error_message"
          ><p>{{ error_form }}</p></span
        >

        <br />

        <!-- barra de progreso, mientras carga el proceso -->
        <div v-if="show_spinner" class="text-center">
          <v-progress-circular
            indeterminate
            :rotate="-90"
            :size="50"
            :width="5"
            color="#2E7D32"
          >
          </v-progress-circular>
        </div>
      </v-container>
    </v-card>
  </v-app>
</template>

<script>
import { db } from "@/main";
import firebase from "firebase";
import * as faker from "faker";
import navBar from "@/components/navbar";

export default {
  components: { navBar },

  data() {
    return {
      show_spinner: false,
      email: "",
      password: "",
      error_email: "",
      error_password: "",
      error_form: "",
      showPass: false,
    };
  },
  methods: {
    login: async function () {
      this.error_form = "";
      this.show_spinner = true;

      var a = this.errorEmail();
      var b = this.errorPass();

      if (a && b) {
        var that = this;

        firebase
          .auth()
          .signInWithEmailAndPassword(this.email, this.password)
          .then(async (userCredential) => {
            // Signed in
            var user = userCredential.user;

            // if (user.emailVerified == false) {
            //   that.error_form = "Para iniciar sesión tienes que verificar tu correo";
            // } else {
              await db
                .collection("users")
                .doc(user.uid)
                .get()
                .then(async (userInfo) => {
                  if (userInfo.data().role == "admin") {
                    this.$router.push("/user_admin").catch((err) => {
                      console.log(err);
                    });
                  } else {
                    setTimeout(
                      () =>
                        this.$router.push("/my_space").catch((err) => {
                          console.log(err);
                        }),
                      800
                    );
                  }
                });
            // }
            // ...
          })
          .catch((error) => {
            that.error_form = "Usuario o contraseña equivocados.";
          });
      }

      this.show_spinner = false;
    },
    errorEmail() {
      if (this.email != "") {
        if (this.validEmail(this.email)) {
          this.error_email = "";
          return true;
        } else {
          this.error_email = "Teclear un correo válido.";
          return false;
        }
      } else {
        this.error_email = "El correo no puede estar vacío.";
        return false;
      }
    },
    errorPass() {
      if (this.password != "") {
        if (this.password.length > 5) {
          this.error_password = "";
          return true;
        } else {
          this.error_password = "La contraseña debe tener un mínimo de 6 caracteres.";
          return false;
        }
      } else {
        this.error_password = "La contraseña no puede estar vacía.";
        return false;
      }
    },
    validEmail: function (email) {
      var re = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      return re.test(email);
    },
    validPass: function (pass) {
      var re = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?!.*\s).{6,30}$/;
      return re.test(pass);
    },
  },
  mounted() {
    //redireccion al inicio en caso de ya estar autentificado
    if (this.$store.state.authModule.logged) {
      this.$router.push({ path: "/" });
    }
  },
};
</script>

<style scoped>
.register-p {
  font-weight: 900;
  color: rgba(253, 246, 254, 0.96);
}

.register-input {
  outline: none;
  border-bottom: 2px solid white;
  width: 100%;
  color: white;
  text-align: center;
}

#backGND {
  background-image: url("../assets/login.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}

.error_message {
  font-weight: 900;
  font-size: 1.1em;
  color: red;
  text-align-last: center;
}
a {
  text-decoration: none;
}

@media screen and (max-width: 1024px) {
  #card_login {
    margin-left: 30% !important;
    width: 40% !important;
  }
}

@media screen and (max-width: 800px) {
  #card_login {
    margin-left: 25% !important;
    width: 50% !important;
  }
}

@media screen and (max-width: 600px) {
  #card_login {
    margin-left: 20% !important;
    width: 60% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue